// extracted by mini-css-extract-plugin
export var border = "_r-7";
export var brand = "_r-r";
export var button = "_r-j";
export var center = "_r-9";
export var centered = "_r-5";
export var closeButton = "_r-b";
export var disabledWrapper = "_r-k";
export var error = "_r-n";
export var extraLarge = "_r-4";
export var extraSmall = "_r-1";
export var fill = "_r-g";
export var footer = "_r-f";
export var footerAction = "_r-h";
export var footerButtons = "_r-i";
export var header = "_r-6";
export var icon = "_r-m";
export var info = "_r-q";
export var inline = "_r-8";
export var large = "_r-3";
export var main = "_r-c";
export var modal = "_r-0";
export var neutral = "_r-s";
export var noPadding = "_r-e";
export var none = "_r-t";
export var scrollable = "_r-d";
export var small = "_r-2";
export var success = "_r-p";
export var tight = "_r-l";
export var titleIcon = "_r-a";
export var warn = "_r-o";